(() => {
  'use strict';
  if (window.shirtyAutoDarkImages) return;
  window.shirtyAutoDarkImages = true;
  const selector = '.product-item__image img, .product-gallery img, .s2-imgbox img, .cart-item__thumbnail img';
  const states = new WeakMap();
  const cache = new Map();
  const queue = [];
  let active = 0;
  const dark = () => document.body.classList.contains('s2-dark');
  const css = document.createElement('style');
  css.textContent = 'body.s2-dark img[data-s2-auto-mask]{-webkit-mask-image:var(--s2-auto-mask)!important;mask-image:var(--s2-auto-mask)!important;-webkit-mask-size:var(--s2-mask-fit,contain)!important;mask-size:var(--s2-mask-fit,contain)!important;-webkit-mask-position:var(--s2-mask-position,center)!important;mask-position:var(--s2-mask-position,center)!important;-webkit-mask-repeat:no-repeat!important;mask-repeat:no-repeat!important}';
  document.head.appendChild(css);
  function makeMask(data, w, h) {
    const seen = new Uint8Array(w * h), todo = new Int32Array(w * h);
    let head = 0, tail = 0;
    function add(p) {
      if (p < 0 || p >= seen.length || seen[p]) return;
      seen[p] = 1;
      const i = p * 4, r = data[i], g = data[i + 1], b = data[i + 2];
      if (data[i + 3] < 12 || (Math.min(r, g, b) >= 239 && Math.max(r, g, b) - Math.min(r, g, b) <= 12)) {
        seen[p] = 2; todo[tail++] = p;
      }
    }
    for (let x = 0; x < w; x++) { add(x); add((h - 1) * w + x); }
    for (let y = 0; y < h; y++) { add(y * w); add(y * w + w - 1); }
    while (head < tail) {
      const p = todo[head++], x = p % w;
      if (x) add(p - 1);
      if (x + 1 < w) add(p + 1);
      add(p - w); add(p + w);
    }
    let center = 0, removed = 0;
    for (let y = Math.floor(h * .3); y < h * .7; y++) {
      for (let x = Math.floor(w * .35); x < w * .65; x++) {
        center++;
        if (seen[y * w + x] === 2) removed++;
      }
    }
    if (tail < w * h * .015 || tail > w * h * .8 || removed > center * .025) return null;
    for (let p = 0; p < seen.length; p++) {
      const i = p * 4;
      data[i] = data[i + 1] = data[i + 2] = 255;
      let alpha = seen[p] === 2 ? 0 : 255;
      const x = p % w, y = Math.floor(p / w);
      if (alpha) {
        for (let dy = -2; dy <= 2; dy++) {
          for (let dx = -2; dx <= 2; dx++) {
            if (x + dx < 0 || x + dx >= w || y + dy < 0 || y + dy >= h) continue;
            if (seen[(y + dy) * w + x + dx] === 2) alpha = Math.min(alpha, Math.max(Math.abs(dx), Math.abs(dy)) === 1 ? 0 : 180);
          }
        }
      }
      data[i + 3] = alpha;
    }
    return data;
  }
  function build(src) {
    return new Promise(resolve => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      const timer = setTimeout(() => resolve(null), 10000);
      image.onerror = () => { clearTimeout(timer); resolve(null); };
      image.onload = () => {
        clearTimeout(timer);
        try {
          const canvas = document.createElement('canvas');
          const scale = Math.min(1, 700 / Math.max(image.width, image.height));
          canvas.width = Math.round(image.width * scale); canvas.height = Math.round(image.height * scale);
          const ctx = canvas.getContext('2d', {willReadFrequently: true});
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const corners = [0, canvas.width - 1, (canvas.height - 1) * canvas.width, canvas.width * canvas.height - 1];
          if (corners.every(p => pixels.data[p * 4 + 3] < 12)) return resolve(null);
          if (!makeMask(pixels.data, canvas.width, canvas.height)) return resolve(null);
          ctx.putImageData(pixels, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } catch { resolve(null); }
      };
      image.src = src;
    });
  }
  function pump() {
    while (active < 2 && queue.length) {
      const job = queue.shift(); active++;
      build(job.src).then(job.resolve).finally(() => { active--; pump(); });
    }
  }
  function eligible(img) {
    const card = img.closest('.product-item, .cart-item, .s2-card, .s2-imgbox');
    const title = (card ? card.textContent : document.querySelector('.main-product h1')?.textContent) || '';
    return /t[\s-]?shirt/i.test(title + ' ' + img.alt + ' ' + (img.closest('a')?.getAttribute('href') || ''));
  }
  function process(img) {
    if (!dark() || !img.isConnected || !img.complete || !img.naturalWidth || !eligible(img)) return;
    const src = img.currentSrc || img.src;
    if (!src || src.startsWith('data:') || states.get(img) === src) return;
    states.set(img, src); img.removeAttribute('data-s2-auto-mask');
    if (!cache.has(src)) {
      cache.set(src, new Promise(resolve => { queue.push({src, resolve}); pump(); }));
      if (cache.size > 100) cache.delete(cache.keys().next().value);
    }
    cache.get(src).then(mask => {
      if (!mask || !img.isConnected || (img.currentSrc || img.src) !== src) return;
      const style = getComputedStyle(img);
      img.style.setProperty('--s2-auto-mask', `url("${mask}")`);
      img.style.setProperty('--s2-mask-fit', style.objectFit === 'fill' ? '100% 100%' : style.objectFit === 'cover' ? 'cover' : 'contain');
      img.style.setProperty('--s2-mask-position', style.objectPosition);
      img.setAttribute('data-s2-auto-mask', '');
    });
  }
  const observer = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) process(e.target); }), {rootMargin: '160px'});
  const watched = new WeakSet();
  function scan() {
    if (!dark()) return;
    document.querySelectorAll(selector).forEach(img => {
      if (!watched.has(img)) {
        watched.add(img); observer.observe(img);
        img.addEventListener('load', () => process(img));
      }
      if (states.get(img) === (img.currentSrc || img.src)) return;
      const box = img.getBoundingClientRect();
      if (box.bottom >= -160 && box.top <= innerHeight + 160) process(img);
    });
  }
  let pending = false;
  function schedule() {
    if (pending || !dark()) return;
    pending = true; requestAnimationFrame(() => { pending = false; scan(); });
  }
  new MutationObserver(records => {
    for (const r of records) {
      if (r.type === 'attributes' && r.target.tagName === 'IMG') {
        r.target.removeAttribute('data-s2-auto-mask'); states.delete(r.target);
      }
    }
    schedule();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']});
  new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  scan();
})();
